import { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";
import { getPushState, enablePush } from "@/lib/push";
import { toast } from "sonner";

// Indicateur d'en-tête de l'état des notifications push. Un tap (quand OFF) demande la
// permission + (ré)abonne l'appareil. N'affecte jamais la réception des données in-app.
export default function NotifBadge({ slug }) {
  const [state, setState] = useState(getPushState());
  const [busy, setBusy] = useState(false);
  useEffect(() => { const id = setInterval(() => setState(getPushState()), 3000); return () => clearInterval(id); }, []);
  if (state === "unsupported") return null;
  const on = state === "granted";
  const click = async () => {
    if (busy) return;
    if (on) { toast.success("Notifications activées sur cet appareil"); return; }
    setBusy(true);
    const res = await enablePush(slug, false);
    setState(getPushState());
    setBusy(false);
    if (res.ok) toast.success("Notifications activées");
    else toast.error(`Notifications non activées : ${res.reason}`);
  };
  return (
    <button data-testid="notif-badge" onClick={click} disabled={busy}
      title={on ? "Notifications activées" : "Activer les notifications"}
      className={`inline-flex items-center gap-1 rounded-full border px-2 py-0.5 text-[10px] font-semibold transition-colors ${on ? "text-emerald-400 border-emerald-500/40" : "text-stone-400 border-[#1B3028] hover:border-[#C69C4A]/50"}`}>
      {on ? <Bell className="w-3 h-3" /> : <BellOff className="w-3 h-3" />}
      {on ? "Notifs ON" : "Notifs OFF"}
    </button>
  );
}
